import { render } from "./TheMyCollectionItemListView.vue?vue&type=template&id=3fdf7954&scoped=true&ts=true"
import script from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionItemListView.vue?vue&type=script&lang=ts"

import "./TheMyCollectionItemListView.vue?vue&type=style&index=0&id=3fdf7954&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdf7954"]])

export default __exports__